import { ComponentType, Dispatch, useEffect } from 'react';
import { UserDetail } from 'types/user';
import { Permission } from '../../types/common';
import localStorageService from '../../helpers/localStorageService';

interface PermissionProps {
  componentPermissions: string[];
  setPermission: Dispatch<boolean>;
}

export function withPermission<P>(Component: ComponentType<P>) {
  const PermissionControlled = (props: P & PermissionProps) => {
    //  Props destructuring
    const { componentPermissions, setPermission } = props;
    useEffect(() => {
      //  Get user details from local storage
      const userInfo: UserDetail = localStorageService.get('userInfo');
      const userPermissions: Permission[] | undefined = userInfo?.role?.permissions;

      //  Compute user access
      setPermission(
        componentPermissions.some(key =>
          userPermissions?.find(item => item.permissionId === key && item.isActive === true),
        ),
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* eslint-disable react/jsx-props-no-spreading */
    return <Component {...props} />;
  };
  return PermissionControlled;
}

export default withPermission;
